import { Clock } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ds/EmptyState'
import { forwardChannel } from '@/lib/routing'

export interface FactoryComingSoonPageProps {
  title: string
  description?: string
}

/**
 * Placeholder page for factories whose frontend wiring is still pending.
 * Delivery 4a ships only Viral Shorts; Product Review / Football / NASA
 * APOD forms arrive in later deliveries, but the sub-routes already exist
 * so links from the selector don't 404.
 */
export function FactoryComingSoonPage({ title, description }: FactoryComingSoonPageProps) {
  return (
    <EmptyState
      icon={<Clock />}
      title={`${title} — em breve`}
      description={
        description ??
        'Estamos migrando os formulários das outras factories. O endpoint do backend já existe; a UI chega nas próximas entregas.'
      }
      action={
        <Link to="/factory" search={forwardChannel}>
          <Button variant="secondary">Voltar para Factory</Button>
        </Link>
      }
    />
  )
}
